import React, { useState, useEffect, useContext } from 'react';
import Connects from './Connects';
import { Channel } from '@missionlabs/smartagent-lib-shared/build/form-templates/form-template.schema';
import Directory from './Directory';
import useHasFeature, { AppFeatures } from 'hooks/useHasFeature';
import { Tabs, Tab, TriggeredPopup } from '@missionlabs/smartagent-app-components';
import { getBodyWidth } from 'utils';

import ContactBtn from 'images/directory-icon.svg';
import './quick-dialler.scss';

import { HomeContext} from 'views/Home'
import { DialerControlButton } from 'components';


interface Props {
    channel: Channel
}

interface IDiallerContext {
    closeQuickDialler?(): void;
}

export const QuickDiallerContext = React.createContext<IDiallerContext>({});

const QuickDialler: React.FC<Props> = ({ channel }) => {
    //  state used to control if the popup is set to active and rendered on screen
    const [isActive, setActiveState] = useState(false)
    // shared state showing if the dialler popup has been opened 
    const { diallerOpened, setDiallerOpened } = useContext(HomeContext);

    useEffect(()=> {
        if(diallerOpened === true ) {
            // if the dialler has been opened hide the popup in this component
            setActiveState(false)
            // reset the dialler Opened state to false again so this code will run correctly the next time the dialler is opened
            setDiallerOpened?.(false)
        }
    }, [diallerOpened, setDiallerOpened])

    const hasFeature = useHasFeature();

    return (
        <TriggeredPopup
            onOpen={()=> setActiveState(true)}
            onClose={()=> setActiveState(false)}
            active={isActive}
            noShadow
            className="dialler-popup sa-quick-dialler"
            fromCenter={getBodyWidth() > 600}
            trigger={
                <DialerControlButton
                    isFocused={isActive}
                    className='md-mar-right'
                    type="button"
                >
                    <img src={ContactBtn} alt="Quick connect" title="Quick Connect" />
                </DialerControlButton>
            }
            render={(closeQuickDialler) => (
                <QuickDiallerContext.Provider value={{ closeQuickDialler}}>
                    <Tabs>
                        <Tab title="Quick Connects">
                            <Connects channel={channel} />
                        </Tab>
                        {hasFeature(AppFeatures.EXTERNAL_DIRECTORY) || hasFeature(AppFeatures.MS_TEAMS_DIRECTORY) ?
                            <Tab title="Directory">
                                <Directory />
                            </Tab> :
                            <></>
                        }
                    </Tabs>
                </QuickDiallerContext.Provider>
            )}
        />
    )
}

export default QuickDialler;